import React from "react"
import { FormattedMessage, injectIntl } from "react-intl"
import { Link } from "react-router-dom"
import { Header } from "../../common/headers"
import Icon from "../../common/icon/icon.component"
import IntlProps from "../../state/helpers/IntlProps"
import { STOCK_LOCATIONS_PAGE_MESSAGES } from "../../utils/inventory"
import { MainTabsComponent } from "../components"
import { LocationListingSection } from "../sections"

const StockLocations = (props: IntlProps) => {

    return (
        <>
            <MainTabsComponent/>
            <Header title={props.intl.formatMessage(STOCK_LOCATIONS_PAGE_MESSAGES["header"])}>
                <div className="flex flex-column">
                    <div className="text-align-right">
                        <Link to="/inventory/stock-locations/new" className="btn btn-primary">
                            <Icon value={"plus-circle"}/>
                            <FormattedMessage
                                id="inventory.stock_locations.list.headers.new_stock_location_btn"
                                defaultMessage="New stock location"
                            />
                        </Link>
                    </div>
                </div>
            </Header>
            <hr/>
            <LocationListingSection/>
        </>
    )
}

export default injectIntl(StockLocations)



// WEBPACK FOOTER //
// ./src/inventory/pages/StockLocations.tsx